<form class="panel" (ngSubmit)="onSubmit()" [hidden]="hidden()" data-testid="wcg-create-entity-panel-organization">
    @if ($referenceDataError()) {
        <p class="field__error" data-testid="wcg-create-entity-org-reference-data-error">
            Unable to load organization types and countries. Please refresh and try again.
        </p>
    }
    <h3 class="panel__section-title">Organization Details</h3>
    <div class="field">
        <label class="field__label" for="wcg-org-name">Organization Name<span class="field__required">*</span></label>
        <input id="wcg-org-name" class="field__input" type="text" placeholder="Enter name" [formField]="$form.name" data-testid="wcg-create-entity-org-name" />
        @if ($form.name().invalid() && $form.name().touched()) {
            <span class="field__error">Organization name is required.</span>
        }
    </div>
    <div class="field-row">
        <div class="field">
            <label class="field__label" id="wcg-org-primary-type-label">Primary Organization Type<span class="field__required">*</span></label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select
                    aria-labelledby="wcg-org-primary-type-label"
                    placeholder="Choose primary org type"
                    [formField]="$form.primaryType"
                    data-testid="wcg-create-entity-org-primary-type"
                >
                    @for (type of $orgTypes(); track type.organization_type_key) {
                        <mat-option [value]="type.organization_type_key">{{ type.organization_type_name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if ($form.primaryType().invalid() && $form.primaryType().touched()) {
                <span class="field__error">Primary organization type is required.</span>
            }
        </div>
        <div class="field">
            <label class="field__label" id="wcg-org-additional-type-label">Additional Organization Type</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select
                    multiple
                    aria-labelledby="wcg-org-additional-type-label"
                    placeholder="Choose additional org type"
                    [formField]="$form.additionalType"
                    data-testid="wcg-create-entity-org-additional-type"
                >
                    @for (type of $additionalOrgTypes(); track type.organization_type_key) {
                        <mat-option [value]="type.organization_type_key">{{ type.organization_type_name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <label class="checkbox">
        <input type="checkbox" [formField]="$form.isIrbAffiliated" data-testid="wcg-create-entity-org-irb-affiliated" />
        <span>This Org is an IRB Affiliated Institution.</span>
    </label>

    <h3 class="panel__section-title">Address Details</h3>
    <div class="field">
        <label class="field__label" for="wcg-org-address-1">Address Line 1<span class="field__required">*</span></label>
        <input id="wcg-org-address-1" class="field__input" type="text" placeholder="Enter address line 1" [formField]="$form.addressLine1" data-testid="wcg-create-entity-org-address-1" />
        @if ($form.addressLine1().invalid() && $form.addressLine1().touched()) {
            <span class="field__error">Address is required.</span>
        }
    </div>
    <div class="field">
        <label class="field__label" for="wcg-org-address-2">Address Line 2</label>
        <input id="wcg-org-address-2" class="field__input" type="text" placeholder="Enter address line 2" [formField]="$form.addressLine2" data-testid="wcg-create-entity-org-address-2" />
    </div>
    <div class="field-row">
        <div class="field">
            <label class="field__label" for="wcg-org-city">City<span class="field__required">*</span></label>
            <input id="wcg-org-city" class="field__input" type="text" placeholder="Enter city" [formField]="$form.city" data-testid="wcg-create-entity-org-city" />
            @if ($form.city().invalid() && $form.city().touched()) {
                <span class="field__error">City is required.</span>
            }
        </div>
        <div class="field">
            <label class="field__label" id="wcg-org-state-label" for="wcg-org-state">State/province<span class="field__required">*</span></label>
            @if ($states().length > 0) {
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select
                        id="wcg-org-state"
                        aria-labelledby="wcg-org-state-label"
                        placeholder="Choose a state/province"
                        [formField]="$form.state"
                        data-testid="wcg-create-entity-org-state"
                    >
                        @for (state of $states(); track state) {
                            <mat-option [value]="state">{{ state }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <input id="wcg-org-state" class="field__input" type="text" placeholder="Enter state" [formField]="$form.state" data-testid="wcg-create-entity-org-state" />
            }
            @if ($form.state().invalid() && $form.state().touched()) {
                <span class="field__error">State is required.</span>
            }
        </div>
    </div>
    <div class="field-row">
        <div class="field">
            <label class="field__label" for="wcg-org-zip">Zip Code<span class="field__required">*</span></label>
            <input id="wcg-org-zip" class="field__input" type="text" placeholder="Enter zip code" [formField]="$form.zipCode" data-testid="wcg-create-entity-org-zip" />
            @if ($form.zipCode().invalid() && $form.zipCode().touched()) {
                <span class="field__error">Zip code is required.</span>
            }
        </div>
        <div class="field">
            <label class="field__label" id="wcg-org-country-label">Country<span class="field__required">*</span></label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select aria-labelledby="wcg-org-country-label" placeholder="Select country" [formField]="$form.country" data-testid="wcg-create-entity-org-country">
                    @for (country of $countries(); track country.country_key) {
                        <mat-option [value]="country.country_key">{{ country.iso_country }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if ($form.country().invalid() && $form.country().touched()) {
                <span class="field__error">Country is required.</span>
            }
        </div>
    </div>
</form>
